import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Contato } from '../models/contato';
import { Filtro } from '../models/filtro';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { ContatoService } from '../services/contato.service';
import { UtilitarioService } from '../services/utilitario.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { AutenticacaoService } from '../services/autenticacao.service';
import { PlatformLocation } from '@angular/common';
import swal from 'sweetalert2';
import { FuncionarioService } from '../services/funcionario.service';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { ContatoAnexoModalComponent } from '../modals/contato-anexo-modal/contato-anexo-modal.component';
import { PremissasService } from '../services/premissas.service';
import { SelecionarTagModalComponent } from '../modals/selecionar-tag-modal/selecionar-tag-modal.component';
import { TipoTag } from '../models/enum';
import { TagGiService } from '../services/tag-gi.service';
import { TagGi } from '../models/tag-gi';
import { ContatoStatus } from '../models/contato-status';
import { ContatoStatusService } from '../services/contato-status.service';
import { SelecionarStatusOrcamentoModalComponent } from '../modals/selecionar-status-orcamento-modal/selecionar-status-orcamento-modal.component';
import { UsuarioLogado } from '../models/usuario-logado';
import { PaginatorService } from '../services/paginator.service';
import { TransferenciaItemsVendedorModalComponent } from '../modals/transferencia-items-vendedor-modal/transferencia-items-vendedor-modal.component';
import { PremissasSistema } from '../models/premissas-sistema';
import { SolicitacoesTokenIntegradorModalComponent } from '../modals/solicitacoes-token-integrador-modal/solicitacoes-token-integrador-modal.component';
import {
  ImportarTransferenciaVendedoresModalComponent
} from "../modals/importar-transferencia-vendedores-modal/importar-transferencia-vendedores-modal.component";
import { ClienteService } from "../services/cliente.service";

// jquery
declare const $: any;

@Component({
  selector: 'app-contato',
  templateUrl: './contato.component.html',
  styleUrls: ['./contato.component.scss']
})
export class ContatoComponent implements OnInit, OnDestroy {

  // variáveis
  contatoStatus: ContatoStatus[] = [];
  contatosFiltrados: Contato[] = [];
  carregando = true;
  campoOrdenacao = 'apelido';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  statusSelecionado = false;
  vendedores: CRMHierarquiaUsuario[] = [];
  vendedorSelecionado;
  administrador;
  tiposDeStatus = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  status = 1;

  contatoStatusSelecionado = undefined;
  tiposPesquisa = [{ id: 0, nome: 'Documento' }, { id: 1, nome: 'Fantasia' }, { id: 2, nome: 'Razão' }, { id: 3, nome: 'Email' }];
  tipoPesquisaSelecionado: number;
  pesquisa: string;

  trocarRazaoPorNomeFantasia = false;
  naoRespTimePesqCliente = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  fidelidadeGoSolar = false;

  pUsarDocuSign = false;

  qntColunas = 7;

  tagsSelecionadas = [];
  tagsDoIntegrador: TagGi[] = [];

  integrador = false;

  modulosAtivos: Number[] = [];

  usuarioLogado: UsuarioLogado;

  premissasSistema = new PremissasSistema();
  controleSolicitacaoToken = false;

  constructor(
    private contatoService: ContatoService,
    public utilitarioService: UtilitarioService,
    private funcionarioService: FuncionarioService,
    private router: Router,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private platformLocation: PlatformLocation,
    private autenticacaoService: AutenticacaoService,
    public dialog: MatDialog,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private premissasService: PremissasService,
    private tagService: TagGiService,
    private premissaService: PremissasService,
    private contatoStatusService: ContatoStatusService,
    private paginatorService: PaginatorService,
    private clienteService: ClienteService
  ) { }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.buscarPremissasSistema();
    this.buscarPremissaControleSolicitacaoToken();

    await this.buscarModulosAtivos();

    this.integrador = await this.globalService.integrador();

    this.buscarPremissaUsarDocuSign();
    this.buscarTags();

    this.route.data.subscribe(async p => {
      this.statusSelecionado = p.status;

      if(p.status) this.qntColunas++;

      if(!p.status) this.buscarContatoStatus();

      this.administrador = await this.globalService.administrador();

      await this.buscarNaoRespTimePesqCliente();

      this.buscarVendedores();
      this.buscarTrocarRazaoPorNomeFantasia();
    });
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaControleSolicitacaoToken() {
    this.carregandoService.mostra('buscaPremissaControleSolicitacaoToken');
    this.premissasService.consultarControleSolicitacaoTokenIntegrador().subscribe((resultado: any) => {
      this.controleSolicitacaoToken = resultado.valor;
      this.carregandoService.esconde('buscaPremissaControleSolicitacaoToken');
    }, (erro) => {
      this.carregandoService.esconde('buscaPremissaControleSolicitacaoToken');
    });
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some(p => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.carregandoService.mostra('buscarModulosAtivos');

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.carregandoService.esconde('buscarModulosAtivos');
    } catch (erro) {
      this.carregandoService.esconde('buscarModulosAtivos');
      this.notificacaoService.erro(erro);
    }
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags(TipoTag.integrador).subscribe(
      (tags) => {
        this.tagsDoIntegrador = tags;
        this.tagsDoIntegrador.unshift({ id: -1, tag: 'Sem tags', icone: 'label_off', cor: '#000', tipo: TipoTag.integrador, somenteApi: false, disabled: false, tipoVinculo: 0 });

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarContatoStatus() {
    this.carregandoService.mostra('buscarContatoStatus');

    this.contatoStatusService.consultar().subscribe(
      (contatoStatus) => {
        this.contatoStatus = contatoStatus;
        this.qntColunas++;

        this.carregandoService.esconde('buscarContatoStatus');
      },
      (erro) => {
        this.carregandoService.esconde('buscarContatoStatus');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarContatos();
    this.paginator.firstPage();
  }

  buscarContatos() {
    this.carregandoService.mostra('buscaContatos');

    this.contatoService.consultarContatosComPaginacao(
      this.filtroNome.Valor,
      this.statusSelecionado,
      (this.vendedorSelecionado === 0 ? undefined : this.vendedorSelecionado === -1 ? this.usuarioLogado.id : this.vendedorSelecionado),
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc',
      this.status,
      this.tipoPesquisaSelecionado,
      this.pesquisa,
      this.tagsSelecionadas !== null && this.tagsSelecionadas !== undefined && this.tagsSelecionadas.length > 0 ? this.tagsSelecionadas.join(',') : undefined,
      this.contatoStatusSelecionado
    ).subscribe(dados => {
      this.contatosFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaContatos');
    }, (erro) => {
      this.carregandoService.esconde('buscaContatos');
      this.notificacaoService.erro(erro);
    });
  }

  buscarVendedores() {
    if (this.naoRespTimePesqCliente || this.administrador || !this.usuarioLogado.verSomenteHierarquia) {
      this.carregandoService.mostra('buscarVendedores');

      this.funcionarioService.consultarFuncionariosPedido(false).subscribe(resp => {
        this.vendedores = resp.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));

        if (this.vendedores.length > 1) {
          this.vendedores.unshift({ idFuncion: 0, nome: 'Todos' });
        }
        this.carregandoService.esconde('buscarVendedores');
      }, (erro) => {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      });
    }
    else {
      this.carregandoService.mostra('buscaUsuarios');

      this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
        this.vendedores = resp;

        this.vendedores.splice(this.vendedores.
          indexOf(this.vendedores.find(p => p.idFuncion === Number(this.usuarioLogado.id))), 1);

        if (this.vendedores.length > 0) {
          const todos = new CRMHierarquiaUsuario();
          todos.idFuncion = 0;
          todos.nome = 'Todos';
          this.vendedores.unshift(todos);
        }

        const somenteEu = new CRMHierarquiaUsuario();
        somenteEu.idFuncion = -1;
        somenteEu.nome = 'Somente eu';
        this.vendedores.unshift(somenteEu);

        this.carregandoService.esconde('buscaUsuarios');
      }, (erro) => {
        this.carregandoService.esconde('buscaUsuarios');
        this.notificacaoService.erro(erro);
      });
    }
  }


  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarContatos();
  }

  retornaPerfil(perfil) {
    switch (perfil) {
    case 1:
      return 'Op';

    case 2:
      return 'Ad';

    default:
      break;
    }
  }

  retornaClassePerfil(perfil) {
    switch (perfil) {
    case 1:
      return 'badge-primary';

    case 2:
      return 'badge-info';

    default:
      break;
    }
  }

  transformarEmCliente(contato: Contato) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente transformar esse contato em integrador?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.router.navigateByUrl('/integradores/novo', { state: { contato } });
      }
    });
  }

  editarCliente(contato: Contato) {
    this.router.navigate(['/integradores/editar', contato.idCliente]);
  }

  ngOnDestroy(): void {}

  reenviarEmail(contato: Contato) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente Reenviar o Email para liberação de acesso desse Integrador?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('resetandoSenha');

        const url = location.origin + this.platformLocation.getBaseHrefFromDOM();

        this.autenticacaoService.esqueceuSenha(contato.email, url).subscribe((data: any) => {
          this.notificacaoService.sucesso(
            'Email Reenviado com sucesso!!!');

          this.router.navigate(['/']).then(() => {
            this.carregandoService.esconde('resetandoSenha');
            this.carregando = false;
          });

        }, (erro: any) => {
          this.notificacaoService.erro(erro);
          this.carregandoService.esconde('resetandoSenha');
        });
      }
    });
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 0
      },
      panelClass: 'modal-card'
    });
  }

  exportarContatos() {
    this.carregandoService.mostra('exportaContatos');

    const title: string = this.statusSelecionado ? 'Integradores' : 'Contatos';
    const ids = this.contatosFiltrados.map(c => c.idGIContato);

    this.contatoService.exportarContatos(ids, title).subscribe(data => {
      this.carregandoService.esconde('exportaContatos');
      this.utilitarioService.saveBlob(data, title + '.xlsx');
    }, (erro) => {
      this.carregandoService.esconde('exportaContatos');
      this.notificacaoService.erro('Não foi possível exportar os contatos');
    });
  }

  exportarModeloTranfVendedor() {
    this.carregandoService.mostra('exportaModeloTranfVendedor');

    this.clienteService.exportarPlanilhaTransVendedores().subscribe(data => {
      this.carregandoService.esconde('exportaModeloTranfVendedor');
      this.utilitarioService.saveBlob(data, 'TransferenciaVendedores.xlsx');
    }, (erro) => {
      this.carregandoService.esconde('exportaModeloTranfVendedor');
      this.notificacaoService.erro("Não foi possível baixar a planilha");
    });
  }

  importarModeloTranfVendedor() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ImportarTransferenciaVendedoresModalComponent, {
      width: largura > 1050 ? '1000px' : (($('body').width()).toString() + 'px'),
      data: { },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarContatos();
      }
    });
  }

  anexos(contato: Contato) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(ContatoAnexoModalComponent, {
      width: this.integrador && largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idContato: contato.idGIContato,
        statusSelecionado: this.statusSelecionado,
        podeEditar: true
      },
      panelClass: 'modal-card'
    });
  }

  async buscarNaoRespTimePesqCliente() {
    try {
      this.carregandoService.mostra('buscarNaoRespTimePesqCliente');

      this.naoRespTimePesqCliente = (await this.premissasService.consultarNaoRespTimePesqCliente().toPromise()).valor;

      this.carregandoService.esconde('buscarNaoRespTimePesqCliente');
    } catch (erro) {
      this.carregandoService.esconde('buscarNaoRespTimePesqCliente');
      this.notificacaoService.erro(erro);
    }
  }

  buscarTrocarRazaoPorNomeFantasia() {
    this.carregandoService.mostra('buscarTrocarRazaoPorNomeFantasia');
    this.premissasService.consultarTrocarRazaoPorNomeFantasia().subscribe(fg => {
      if (fg.valor) {
        this.trocarRazaoPorNomeFantasia = fg;
      }

      this.carregandoService.esconde('buscarTrocarRazaoPorNomeFantasia');
    }, (erro) => {
      this.carregandoService.esconde('buscarTrocarRazaoPorNomeFantasia');
      this.notificacaoService.erro(erro);
    });
  }

  conversarPeloWhatsApp(contato: Contato) {
    this.utilitarioService.conversarPeloWhatsapp(contato.telefone, '');
  }

  tags(contato: Contato) {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarPorIdIntegrador(contato.idCliente).subscribe(
      (tags) => {
        const largura = Number(($('body').width()));

        const dialogRef = this.dialog.open(SelecionarTagModalComponent, {
          width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
          data: { idIntegrador: contato.idCliente, tags: tags.map(t => t.id), tipo: TipoTag.integrador },
          panelClass: 'modal-card'
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.buscarContatos();
          }
        });

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaUsarDocuSign() {
    this.carregandoService.mostra('buscarPremissaUsarDocuSign');

    this.premissaService.consultarUsarDocuSign().subscribe(
      (pUsarDocuSign) => {
        this.pUsarDocuSign = pUsarDocuSign.valor;

        if(this.pUsarDocuSign) this.qntColunas++;

        this.carregandoService.esconde('buscarPremissaUsarDocuSign');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissaUsarDocuSign');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarDescricaoContatoStatus(idStatus: number) {
    const status = this.contatoStatus.find(p => p.id === idStatus);
    return status? status.descricao : '';
  }

  alterarContatoStatus(contato: Contato) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(
      SelecionarStatusOrcamentoModalComponent,
      {
        width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
        data: {
          idGIContato: contato.idGIContato,
          idStatus: contato.contatoStatus,
        },
        panelClass: 'modal-card',
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarContatos();
      }
    });
  }

  abrirModalTransferenciaVendedor(contato) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(TransferenciaItemsVendedorModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        somenteIntegrador: true,
        idContato: contato.idGIContato,
        idIntegrador: contato.idCliente,
        funcionarioDe: contato.vendedor,
        nomeIntegrador: contato.razao
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarContatos();
      }
    });
  }

  abrirModalSolicitacoesToken() {
    const largura = Number(($('body').width()));
    this.dialog.open(SolicitacoesTokenIntegradorModalComponent, {
      width: largura > 1000 ? '1100px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });
  }
}
